import { subCenter } from '../../utils/hexGeometry'
import { tileCenter } from './corridors'

// What the rules module's output says should be on screen, read directly and
// independently of model.js, for criterion #8 (rendered state matches the
// module output). Returns Map(key → { state, x, y }).
export function expectedFromResult(result, R) {
    const want = new Map()
    const put = (key, side, s, state) => {
        const { x, y } = subCenter(side, s, R)
        want.set(key, { state, x, y })
    }
    for (const [seat, side] of [['p1', 'self'], ['p2', 'opp']]) {
        const hf = result[seat]?.homefront
        if (!hf) continue
        for (let s = 0; s < hf.subplots.length; s++) {
            const sp = hf.subplots[s]
            put(`cell:${side}:${s}`, side, s, '')
            if (sp.scanned) put(`scan:${side}:${s}`, side, s, String(sp.scanned))
            if (sp.destroyed) put(`crater:${side}:${s}`, side, s, sp.impact ? 'impact' : '')
            if (sp.distance != null) put(`stamp:${side}:${s}`, side, s, `${sp.distanceLetter ?? ''}:${sp.distance}${sp.distanceDead ? ' dead' : ''}`)
        }
        const occupants = { ...hf.structures, ...(hf.broods ?? {}) }
        for (const id of Object.keys(occupants)) {
            const st = occupants[id]
            const brood = st.type === 'base' || !!hf.broods?.[id]
            for (let i = 0; i < st.footprint.length; i++) {
                const s = st.footprint[i]
                const dead = hf.subplots[s].destroyed ? ' dead' : ''
                if (brood) {
                    put(`brood:${id}:${side}:${s}`, side, s, `${i === 0 ? 'nest' : 'drone'}${st.underConstruction ? ' building' : ''}${dead}`)
                } else {
                    put(`structure:${id}:${side}:${s}`, side, s, dead.trim())
                }
            }
            if (brood && st.egg === 'egg') put(`egg:${id}:${side}:${st.footprint[0]}`, side, st.footprint[0], '')
            const rc = st.rocketCells ?? []
            for (let i = 0; i < rc.length; i++) put(`rocket:${id}:${side}:${rc[i]}:${i}`, side, rc[i], '')
        }
    }
    // Item A: corridors, from each side's board.
    for (const [seat, side] of [['p1', 'self'], ['p2', 'opp']]) {
        const board = result[seat]?.board ?? []
        for (let c = 0; c < board.length; c++) {
            const bf = board[c]
            const cap = bf.maxArmyQty ?? 0
            if (cap > 0) {
                const a = tileCenter(side, c, 0, R), b = tileCenter(side, c, cap - 1, R)
                want.set(`lane:${side}:${c}`, { state: String(cap), x: a.x, y: (a.y + b.y) / 2 })
            }
            const slots = bf.slots ?? []
            for (let p = 0; p < slots.length; p++) {
                const tok = slots[p]
                if (!tok) continue
                const { x, y } = tileCenter(side, c, p, R)
                want.set(`drone:${side}:${c}:${p}`, { state: `${tok.kind}${tok.delivered ? ' delivered' : ''}`, x, y })
            }
        }
    }
    return want
}
